import { Helmet } from 'react-helmet-async';
import { SITE_NAME, DEFAULT_TITLE, DEFAULT_DESCRIPTION, absoluteUrl } from '../config/seo';

// Nota: como este sitio es un SPA sin server-side rendering, los bots que NO
// ejecutan JavaScript (Facebook/WhatsApp/LinkedIn al generar la vista previa
// de un link) seguirán viendo el <title>/OG estático de public/index.html en
// vez de estos valores por página. Googlebot sí ejecuta JS y sí ve estos
// valores, así que esto igual mejora el SEO real (title/description/canonical
// por URL), aunque no arregla las vistas previas de redes sociales sin SSR.
const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image,
  type = 'website',
  noindex = false,
  jsonLd,
}) => {
  const tituloCompleto = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const url = absoluteUrl(path);

  return (
    <Helmet>
      <title>{tituloCompleto}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={tituloCompleto} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={tituloCompleto} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
